<div class="encabezado">
  <div>
    <div>
      <h1 class="titulo1">{{ "titles-menu-pages." + title | translate }}</h1>
    </div>
  </div>

  <div *ngIf="selection.size === 0" class="row">
    <div class="col-8">
      <app-filter [ladata]="ladata" (filterChanged)="filterChanged($event)"
        (filterChanged2)="filterChanged($event)"></app-filter>
    </div>
  </div>

  <div *ngIf="selection.size > 0" class="actions_buttons_container">
    <button class="actions_buttons btn btn-hover filter" mat-raised-button (click)="updateSelectedNotes(true)"
      [disabled]="selection.size === 0">
      <span class="icon-alarm-ringing"></span>
      <div>{{ "notes.action_required" | translate }}</div>
    </button>

    <button class="actions_buttons btn btn-hover filter" mat-raised-button (click)="updateSelectedNotes(false)"
      [disabled]="selection.size === 0">
      <span class="icon-alarm-snooze"></span>
      <div>{{ "notes.no_action_required" | translate }}</div>
    </button>
  </div>

  <div class="tabla">
    <mat-paginator [length]="paginator.length ? paginator.length : 25" [pageSize]="paginator.pageSize"
      [pageSizeOptions]="[5, 10, 25, 100]" [hidePageSize]="true" (page)="onPageChange($event)">
    </mat-paginator>
    <div class="table-responsive-wrapper">
    <table mat-table [dataSource]="dataSource" matSort class="full-width-table" aria-label="Clients">

      <ng-container matColumnDef="action_required">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          <i class="pointer" [class.icon-square]="!isAllSelected()" [class.icon-check-square]="isAllSelected()"
            (click)="toggleSelectAll($event)">
          </i>
          {{ 'notes.action_required2' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="default">
          <div class="column-list-actions">
            <i class="clickable" [class.icon-square]="!selection.has(row)"
              [class.icon-check-square]="selection.has(row)" (click)="toggleSelection(row)">
            </i>

            <!-- Ícono para requiere acción -->
            <span *ngIf="row.action_required" (click)="toggleActionRequired(row)"
              [ngClass]="{'selected-icon': selection.has(row)}" class="icon-alarm-ringing text-xl alarm-active">
            </span>

            <!-- Ícono para no requiere acción -->
            <span *ngIf="!row.action_required" (click)="toggleActionRequired(row)"
              [ngClass]="{'selected-icon': selection.has(row)}" class="icon-alarm-snooze text-xl alarm-snooze">
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="reference">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.references" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">

          <div class="column-list ">
            {{ row?.broker_name }}
            <span *ngIf="row?.broker_reference" class="secondary-text">
              <i class="icon-barcode"></i>
              {{ row?.broker_reference }}
            </span>
          </div>
          <div class="column-list ">
            {{ row?.supplier_name }}
            <span *ngIf="row?.supplier_reference" class="secondary-text">
              <i class="icon-barcode"></i>
              {{ row?.supplier_reference }}
            </span>
          </div>
          <div class="column-list ">
            {{ row?.vendor_name }}
            <span *ngIf="row?.vendor_reference" class="secondary-text">
              <i class="icon-barcode"></i>
              {{ row?.vendor_reference }}
            </span>
          </div>




        </td>
      </ng-container>


      <!-- broker_agent Column -->
      <ng-container matColumnDef="broker_agent">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ type === 'broker' ? ("inputs.agent_short" | translate) : ("inputs.broker_agent" | translate) }}
        </th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row?.agent_name">
            {{
            row?.agent_name + " " + row?.agent_lastname
            }}</span>
        </td>
      </ng-container>

      <!-- broker_sales_agent Column -->
      <ng-container matColumnDef="broker_sales_agent">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.broker_sales_agent" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row?.broker_sales_agent?.fullname">{{ row.broker_sales_agent.fullname }}</span>
        </td>
      </ng-container>

      <!-- supplier_agent Column -->
      <ng-container matColumnDef="supplier_agent">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ type === 'supplier' ? ("inputs.agent_short" | translate) : ("inputs.supplier_agent" | translate) }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row?.supplier_reference }}</td>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row?.agent_name">
            {{
            row?.agent_name + " " + row?.agent_lastname
            }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ 'notes.client' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="default">
          <div class="column-list">
            {{ row?.client_name }}
            <span *ngIf="row?.client_type" class="badge text-badge-list"
              [ngClass]="row.client_type | badgeClient">{{
              "inputs." + row.client_type | translate
              }}</span>
          </div>
        </td>
      </ng-container>

      <!-- vehicle Column -->
      <ng-container matColumnDef="vehicle">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ 'notes.vehicle' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="default">
          <div class="column-list">
            <span *ngIf="row?.vehicle">{{ row?.vehicle_brand }} {{ row?.vehicle_model }} {{ row?.vehicle }}
              ({{row?.vehicle_model_year}})</span>
            <span *ngIf="row?.vehicle_status" class="badge text-badge-list"
              [ngClass]="row.vehicle_status | badgeVehicle">{{
              "badge-status_select-stage."
              + row?.vehicle_status | translate }}</span>
          </div>
        </td>
      </ng-container>

      <!-- note Column -->
      <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla note-col-width">
          {{ 'notes.note' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="default">
          {{ row?.content }}
        </td>
      </ng-container>
      <ng-container matColumnDef="stage">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.stage" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="column-list "> <span class="badge text-badge-list"
              [ngClass]="row.order_stage | badgeColor:row.require_action:row.priority">{{
              "badge-status_select-stage." + row?.order_stage | translate
              }}</span></div>

          <span *ngIf="row?.agent_fullname" class="secondary-text">
            <i class="icon-user"></i>
            {{ row?.agent_fullname }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla"
          (click)="onSortChange2('created_at')">
          {{ 'notes.date' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="default">
          <div class="column-list ">
            {{ row?.created_at | formatDateTimePipe}}
          </div>
          <span *ngIf="row?.created_at" class="secondary-text">
            <i class="icon-user"></i>
            {{ row?.updated_by_fullname }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.actions" | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="default">
          <i class="icon-pencil text-success icon-actions clickable" (click)="getOrder(row.order_id)"></i>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns">
      </tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ 'tr-selected': row.action_required }">
      </tr>
    </table>
    </div>

    <mat-paginator [length]="paginator.length" [pageSize]="paginator.pageSize"
      [pageSizeOptions]="paginator.pageSizeOptions" (page)="onPageChange($event)">
    </mat-paginator>

  </div>
  <div class="formulario-derecha-container" [ngClass]="{ 'mostrar-formulario': showForm }">
    <app-form-add-order *ngIf="showForm" [orderData]="orderData" [tab]="tab" (backButtonClick)="cerrarFormulario()"
      (addOrder)="refrescar()" (emitOpenClientForm)="openClientForm()" (emitOpenAssigneeForm)="openAssigneeForm($event)"
      (emitCloseClientForm)="closeClientForm()" (emitCloseAssigneeForm)="closeAssigneeForm()"
      [document_buttons_chico]="document_buttons_chico" [ladata]="ladata"></app-form-add-order>
  </div>

  <div class="formulario-sub-derecha-container" [ngClass]="{'mostrar-formulario': showAssigneeForm }">
    <app-form-show-assignee *ngIf="showAssigneeForm" (backButtonClick)="cerrarAssigneeFormulario()"
      [assignee]="assignee" (addClient)="refreshClients()" [ladata]="ladata">
    </app-form-show-assignee>
  </div>
  <button type="button" class="overlay" *ngIf="showForm" (click)="cerrarFormulario()" 
          aria-label="Cerrar formulario"></button>
</div>
